import { Routes } from '@angular/router';
import { RouteFragment } from '@core/routing/routes/enums/route-fragment';
import { onlyNotLoggedGuard } from '@core/auth/guards/only-not-logged.guard';
import { RouteParam } from '@core/routing/routes/enums/route-param';
import { resolveTitleFor } from '@core/routing/titles/utils/resolve-title-for';
import { Route } from '@core/routing/routes/enums/route';
import { onlyLoggedGuard } from '@core/auth/guards/only-logged.guard';
import { RefreshGuard } from '@core/auth/guards/refresh.guard';

export const routes: Routes = [
  {
    path: RouteFragment.Empty,
    canActivate: [onlyLoggedGuard, RefreshGuard],
    loadComponent: () =>
      import(
        '@core/layouts/components/default-content-layout/default-content-layout.component'
      ).then(c => c.DefaultContentLayoutComponent),
    children: [
      {
        path: RouteFragment.Users,
        children: [
          {
            path: RouteFragment.Empty,
            pathMatch: 'full',
            title: resolveTitleFor(Route.Users),
            loadComponent: () =>
              import(
                '@features/user/pages/user-list-page/user-list-page.component'
              ).then(c => c.UserListPageComponent),
          },
          {
            path: `:${RouteParam.UserId}`,
            children: [
              {
                path: RouteFragment.LoyaltyAccount,
                title: resolveTitleFor(Route.UserLoyaltyAccount),
                loadComponent: () =>
                  import(
                    '@features/user/pages/user-loyalty-account-details-page/user-loyalty-account-details-page.component'
                  ).then(c => c.UserLoyaltyAccountDetailsPageComponent),
              },
              {
                path: RouteFragment.PaymentHistory,
                title: resolveTitleFor(Route.UserPaymentHistory),
                loadComponent: () =>
                  import(
                    '@features/user/pages/user-payment-history-page/user-payment-history-page.component'
                  ).then(c => c.UserPaymentHistoryPageComponent),
              },
            ],
          },
          {
            path: RouteFragment.Wildcard,
            redirectTo: RouteFragment.Empty,
          },
        ],
      },
      {
        path: RouteFragment.CarWashes,
        children: [
          {
            path: RouteFragment.Empty,
            pathMatch: 'full',
            title: resolveTitleFor(Route.CarWashes),
            loadComponent: () =>
              import(
                '@features/car-wash/pages/car-wash-list-page/car-wash-list-page.component'
              ).then(c => c.CarWashListPageComponent),
          },
          {
            path: RouteFragment.Create,
            title: resolveTitleFor(Route.CarWashCreate),
            loadComponent: () =>
              import(
                '@features/car-wash/pages/car-wash-create-page/car-wash-create-page.component'
              ).then(c => c.CarWashCreatePageComponent),
          },
          {
            path: `:${RouteParam.CarWashId}`,
            children: [
              {
                path: RouteFragment.Empty,
                title: resolveTitleFor(Route.CarWashDetails),
                loadComponent: () =>
                  import(
                    '@features/car-wash/pages/car-wash-details-page/car-wash-details-page.component'
                  ).then(c => c.CarWashDetailsPageComponent),
              },
              {
                path: RouteFragment.Update,
                title: resolveTitleFor(Route.CarWashUpdate),
                loadComponent: () =>
                  import(
                    '@features/car-wash/pages/car-wash-update-page/car-wash-update-page.component'
                  ).then(c => c.CarWashUpdatePageComponent),
              },
            ],
          },
          {
            path: RouteFragment.Wildcard,
            redirectTo: RouteFragment.Empty,
          },
        ],
      },
      {
        path: RouteFragment.Settings,
        children: [
          {
            path: RouteFragment.Empty,
            pathMatch: 'full',
            title: resolveTitleFor(Route.Settings),
            loadComponent: () =>
              import(
                '@features/setting/pages/setting-list-page/setting-list-page.component'
              ).then(c => c.SettingListPageComponent),
          },
          {
            path: RouteFragment.Wildcard,
            redirectTo: RouteFragment.Empty,
          },
        ],
      },
      {
        path: RouteFragment.Empty,
        pathMatch: 'full',
        redirectTo: RouteFragment.Users,
      },
    ],
  },
  {
    path: RouteFragment.Auth,
    loadComponent: () =>
      import(
        '@core/layouts/components/auth-content-layout/auth-content-layout.component'
      ).then(c => c.AuthContentLayoutComponent),
    children: [
      {
        path: `${RouteFragment.ResetPassword}/:${RouteParam.ActivationToken}`,
        canActivate: [onlyNotLoggedGuard],
        title: resolveTitleFor(Route.ResetPassword),
        loadComponent: () =>
          import(
            '@features/auth/pages/reset-password-page/reset-password-page.component'
          ).then(c => c.ResetPasswordPageComponent),
      },
      {
        path: RouteFragment.SignOut,
        loadComponent: () =>
          import(
            '@features/auth/pages/sign-out-page/sign-out-page.component'
          ).then(c => c.SignOutPageComponent),
      },
      {
        path: RouteFragment.SignIn,
        canActivate: [onlyNotLoggedGuard],
        title: resolveTitleFor(Route.SignIn),
        loadComponent: () =>
          import(
            '@features/auth/pages/sign-in-page/sign-in-page.component'
          ).then(c => c.SignInPageComponent),
      },
      {
        path: RouteFragment.RecoverPassword,
        canActivate: [onlyNotLoggedGuard],
        title: resolveTitleFor(Route.RecoverPassword),
        loadComponent: () =>
          import(
            '@features/auth/pages/recover-password-page/recover-password-page.component'
          ).then(c => c.RecoverPasswordPageComponent),
      },
      {
        path: RouteFragment.Wildcard,
        redirectTo: RouteFragment.SignIn,
      },
    ],
  },
  {
    path: RouteFragment.NotFound,
    loadComponent: () =>
      import(
        '@features/application-state/pages/not-found-page/not-found-page.component'
      ).then(c => c.NotFoundPageComponent),
  },
  {
    path: RouteFragment.Wildcard,
    redirectTo: RouteFragment.Empty,
  },
];
